import { TextSnippetOutlined } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";

const IndexesGosrRibbonSettings = (periodPriceZoneAutocomplete, typeAutocomplete, searchAutocomplete, showCommentsModal) => {
	return [
		{
			name: "Период и ценовая зона",
			styles: {},
			_children: [
				{
					name: "Subgroup 1",
					orientation: "vertical",
					styles: {},
					_children: [
						{
							icon: <SearchIcon />,
							size: "large",
							type: "custom",
							customJsx: periodPriceZoneAutocomplete(),
							callback: () => {},
							styles: {
								width: "330px",
								pt: "7px",
							},
						},
					],
				},
			],
		},
		{
			name: "Параметры отбора данных",
			styles: {},
			_children: [
				{
					name: "Subgroup 1",
					orientation: "vertical",
					styles: {},
					_children: [
						{
							icon: <SearchIcon />,
							size: "large",
							type: "custom",
							customJsx: typeAutocomplete(),
							callback: () => {},
							styles: {
								width: "220px",
								pt: "7px",
							},
						},
					],
				},
			],
		},
		{
			name: "Поиск",
			styles: {},
			_children: [
				{
					name: "Subgroup 1",
					orientation: "vertical",
					styles: {},
					_children: [
						{
							icon: <SearchIcon />,
							size: "large",
							type: "custom",
							customJsx: searchAutocomplete(),
							callback: () => {},
							styles: {
								width: "330px",
								pt: "7px",
							},
						},
					],
				},
			],
		},
		{
			name: "Примечание",
			_children: [
				{
					_children: [
						{
							name: "Примечание",
							icon: <TextSnippetOutlined />,
							size: "large",
							type: "common",
							callback: () => showCommentsModal(),
						},
					],
				},
			],
		},
	];
};

export default IndexesGosrRibbonSettings;
